import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GojsContextMenuComponent } from './gojs-context-menu.component';

@NgModule({
  imports: [CommonModule, MatMenuModule, FontAwesomeModule],
  declarations: [GojsContextMenuComponent],
  exports: [GojsContextMenuComponent],
})
export class GojsContextMenuModule {}
